/**
 * Imports
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _catchLinks = require('catch-links');

var _catchLinks2 = _interopRequireDefault(_catchLinks);

/**
 * Bind
 */

function bindUrl(_ref, cb) {
  var wnd = _ref.wnd;
  var root = _ref.root;

  if (root === undefined) {
    root = wnd;
  }

  (0, _catchLinks2['default'])(root, pushState);
  wnd.addEventListener('popstate', update);

  // Initialize
  update();

  function update() {
    var _wnd$location = wnd.location;
    var pathname = _wnd$location.pathname;
    var search = _wnd$location.search;

    cb([pathname, search].filter(Boolean).join(''));
  }

  function pushState(url) {
    wnd.history.pushState({}, '', url);
    cb(url);
  }
}

/**
 * Exports
 */

exports['default'] = bindUrl;
module.exports = exports['default'];